import getStarted from "../../images/getStarted.svg";


const Image_Base_Url = process.env.REACT_APP_IMAGE_BASE_URL;

export const getCategoryIcon = ({ icon, color }) => {
    if (icon === "getting-started-icon") {
      return (
        <img
          style={{ width: "40px", height: "40px" }}
          alt="categoryIcon"
          src={getStarted}
        />
      );
    }else if (icon?.includes("media")) {
      return (
        <img
          style={{ width: "40px", height: "40px" }}
          alt="categoryIcon"
          src={Image_Base_Url + icon}
        />
      );
    } else {
      return (
        <span
          style={{ fontSize: "40px", height: "40px", color }}
          className="material-icons-outlined">
          {icon}
        </span>
      );
    }
};